import { useRef } from "react";
import { ReviewsGrid, ReviewsSection } from "@/components/shared";
import { adoptionLabel, type Review } from "@/components/shared/ReviewsSection";
import { reviewCountLabel } from "../provider-reviews";
import { ReviewsReadMoreLink, ReviewsScrollArrows } from "./reviews-controls";
import { useScrollOverflow } from "@wags/tanstack-start/browser";

export function ListingReviewsSection({
    reviewCount,
    reviews,
    organizationId,
}: {
    reviewCount: number;
    reviews: Review[];
    organizationId?: string;
}) {
    const scrollRef = useRef<HTMLDivElement>(null);
    const { canScrollLeft, canScrollRight } = useScrollOverflow(scrollRef);

    return (
        <ReviewsSection>
            <div className="flex items-start justify-between">
                <div className="flex flex-col">
                    <h2 className="text-section-title text-doberman-black text-pretty">
                        What families say
                    </h2>
                    <span className="text-body-small text-doberman-black/50 mt-1">
                        {reviewCountLabel(reviewCount)}
                    </span>
                </div>
                {reviews.length > 1 && (
                    <ReviewsScrollArrows
                        scrollRef={scrollRef}
                        canScrollPrevious={canScrollLeft}
                        canScrollNext={canScrollRight}
                    />
                )}
            </div>

            <ReviewsGrid
                reviews={reviews}
                contextLabel={adoptionLabel}
                scrollRestorationId={
                    organizationId && `listing-reviews-${organizationId}`
                }
                scrollRef={scrollRef}
            />

            {organizationId !== undefined && reviewCount > reviews.length && (
                <ReviewsReadMoreLink providerId={organizationId} />
            )}
        </ReviewsSection>
    );
}
